import Accordion from 'components/shared/accordion/Accordion';
import { AccordionItemProps } from 'components/shared/accordion/Accordion.types';
import HtmlTrans from 'components/shared/HtmlTrans';
import { TFunction } from 'hooks/useI18n';
import MethodologyExperience from './charts/MethodologyExperience';
import MethodologyGender from './charts/MethodologyGender';
import MethodologyRoles from './charts/MethodologyRoles';
import { MethodologySectionProps } from './Methodology.types';

const genderAccordion = (t: TFunction): AccordionItemProps[] => [
  {
    summary: t('mantechcar25.methodology.gender.api-title'),
    details: (
      <HtmlTrans
        ns="developer-career-report-2025"
        i18nKey="mantechcar25.methodology.gender.api-content"
      />
    )
  },
  {
    summary: t('mantechcar25.methodology.gender.question-title'),
    details: (
      <HtmlTrans
        ns="developer-career-report-2025"
        i18nKey="mantechcar25.methodology.gender.question-content"
      />
    )
  }
];

export const METHODOLOGYSECTIONS = (
  t: TFunction
): MethodologySectionProps[] => [
  {
    title: t('mantechcar25.methodology.experience.title'),
    desc: 'mantechcar25.methodology.experience.desc',
    chart: <MethodologyExperience />
  },
  {
    title: t('mantechcar25.methodology.roles.title'),
    desc: 'mantechcar25.methodology.roles.desc',
    chart: <MethodologyRoles />
  },
  {
    title: t('mantechcar25.methodology.gender.title'),
    desc: 'mantechcar25.methodology.gender.desc',
    chart: <MethodologyGender />,
    accordion: <Accordion items={genderAccordion(t)} />
  }
];
